/**
 * Visibility for synthetic page-level element panels (`_inlineElement`).
 * When the wrapped element's shell is false, the whole panel must hide
 * (otherwise empty MExpansion border remains after Label setVisible(false)).
 */
export function resolveInlineElementPanelVisible(input: {
  inlineElement?: boolean
  panelId?: string | number | null
  elementShellVisibleByElementId?: Record<string, boolean> | null
  baseVisible: boolean
}): boolean {
  if (!input.baseVisible) return false
  if (!input.inlineElement) return true
  const id = String(input.panelId ?? '').trim()
  if (!id) return true
  const shellVisible = input.elementShellVisibleByElementId?.[id]
  if (typeof shellVisible === 'boolean') return shellVisible
  return true
}
